import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { deleteCustomNotificationById } from 'api/auth.api';
import { deleteGeneralInformationById } from 'api/auth.api';

export const useGeneralInformationDelete = ({ onSuccess } = {}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteGeneralInformationById,

    onSuccess: (res) => {
      queryClient.invalidateQueries(['generalInformationList']);

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to delete Link',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
